<template>
  <SortSearch default-sort="latest" dimension="OurGraphics" />
</template>

<script>
import SortSearch from '@/components/SortSearch';

export default {
  components: {
    SortSearch
  },
  nuxtI18n: {
    paths: {
      en: '/our-graphics/p/:page',
      es: '/nuestros-vectores/p/:page',
      pt: '/nossos-vetores/p/:page',
      de: '/our-graphics/p/:page'
    }
  }
};
</script>
